module.exports = __webpack_public_path__ + "img/logo.411aea8d.png";